export default __webpack_public_path__ + "static/media/partition.b103af0e.svg";